import CountriesComponent from "../../../Components/system settings/CountriesComponent";
import HeaderBar from "../../../Components/UI/headerbar";

const CountriesPage = () => {
  return (
    <div>
      <HeaderBar title={"إعدادات الدول"} content={"إدارة الدول للنظام"} />

      <CountriesComponent />
    </div>
  );
};

export default CountriesPage;
